import { render } from "./RefundRequestDetailComponent.vue?vue&type=template&id=71288f2c&scoped=true"
import script from "./RefundRequestDetailComponent.vue?vue&type=script&lang=js"
export * from "./RefundRequestDetailComponent.vue?vue&type=script&lang=js"

import "./RefundRequestDetailComponent.vue?vue&type=style&index=0&id=71288f2c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71288f2c"]])

export default __exports__